import React from "react";
import Schedule from "../components/schedule/Schedule";
import Protected from "../components/protected/Protected";
import ComponentContainer from "./ComponentContainer";

class ScheduleContainer extends React.Component {
  componentDidMount() {
    this.props.rootStore.loadingStore.setWindowTitle("ZE - Schedule");
  }

  componentWillUnmount() {
    this.props.rootStore.loadingStore.setWindowTitle("Zone Evaluator");
  }

  render() {
    return (
      <ComponentContainer>
        <Schedule />
      </ComponentContainer>
    );
  }
}

export default Protected(ScheduleContainer);
